import { Icon } from '@instinet-analytics/semantic-ui-components';
import React from 'react';

export const actualVolumeTooltip = {
    title: 'Actual Volume',
    body: (
        <span>
            is today&apos;s market traded volume, from open until now, expressed
            as a % of historical ADV (average daily volume). The volume bars are
            displayed in time bins, which can be changed in the chart&apos;s
            configuration <Icon name="cog" />.
        </span>
    ),
};
export const expectedVolumeTooltip = {
    title: 'Expected Volume',
    body: (
        <span>
            is the market historical traded volume (averaged over the last 20
            days), expressed as a % of historical ADV (average daily volume).
            The volume bars are displayed in time bins, which can be changed in
            the chart&apos;s configuration <Icon name="cog" />.
        </span>
    ),
};
export const auctionTooltip = {
    title: 'Auction',
    body: 'displays the portion of the expected market volume traded (averaged over the last 20 days) in the auction sessions. It is expressed as a % of historical ADV (average daily volume). Hover over the relevant time bin to see opening, intraday or closing auction volumes.',
};
export const cumulativeExpectedVolumeTooltip = {
    body: (
        <>
            <div>
                <span className="title">Cumulative Expected Volume </span>is the
                cumulative sum of the historical market volume (averaged over
                the last 20 days). It is expressed as a % of historical ADV
                (average daily volume).
            </div>
            <div>
                Cumulative volume is calculated by adding all expected volume
                traded in each time bin. It reaches 100% at the end of the day
                as all expected volume is traded by market close.
            </div>
        </>
    ),
};
export const cumulativeActualVolumeTooltip = {
    body: (
        <>
            <div>
                <span className="title">Cumulative Actual Volume </span>is the
                cumulative sum of today&apos;s market volume, from open until
                now, expressed as a % of historical ADV (average daily volume).
            </div>
            <div>
                Cumulative volume is calculated by adding all actual volume
                traded in each time bin. Since this % is relative to historical
                ADV, at end of day it can be less or greater than 100%,
                indicating lighter or heavier volumes today.
            </div>
        </>
    ),
};
export const expectedSpreadTooltip = {
    title: 'Expected Spread',
    body: 'is the historical spread averaged over the last 20 days.',
};
export const expectedVolatilityTooltip = {
    title: 'Expected Volatility',
    body: 'is the historical volatility averaged over the last 20 days.',
};
